import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessStateService } from "../business/business-state.service";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  constructor() {
  }
}
